export default function modelAovType(model) {
  if (!model || !model.aov) return 'variable'
  else if (!model.aov.max) return 'fixed'
  else return 'range'
}



// WEBPACK FOOTER //
// ./src/helpers/modelAovType.js